import * as Yup from "yup";
// import { energyCodes } from "../../../../utils/codes";
import { energyCodes } from "../../../../utils/dataAndFormulas/energyForms";

export function initialValues(energy, period, year, unitsRecorded) {
  console.log("🔍 initialValues llamado con:", {
    hasEnergy: !!energy,
    period,
    year,
    unitsRecorded,
    energySample: energy ? {
      electricity_standard_combined: energy.electricity_standard_combined,
      electricity_standard_domestic: energy.electricity_standard_domestic,
      irec_certificates: energy.irec_certificates
    } : null
  });

  // Función auxiliar para crear la estructura de campo con valores por defecto
  // Esta función asegura que siempre se tenga code y unit, incluso cuando se edita
  const createFieldStructure = (fieldName, energyValue) => {
    if (!energyValue) {
      // Si no existe el campo en energy, usar valores por defecto
      return {
        code: energyCodes[fieldName] || "",
        unit: unitsRecorded?.[fieldName] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      };
    }

    // Si existe el campo, completar las propiedades faltantes
    return {
      code: energyValue.code || energyCodes[fieldName] || "",
      unit: energyValue.unit || unitsRecorded?.[fieldName] || "",
      value: energyValue.value ?? 0,
      reviews: energyValue.reviews || [],
      approvalStatus: energyValue.approvalStatus || "pending",
      files: energyValue.files || [],
    };
  };

  return {
    date: energy?.date || new Date(),
    creator_user: energy?.creator_user || "",
    state: energy?.state || "",
    period: energy?.period || period,
    year: energy?.year || year,

    electricity_standard_combined: createFieldStructure(
      "electricity_standard_combined",
      energy?.electricity_standard_combined
    ),
    electricity_standard_domestic: createFieldStructure(
      "electricity_standard_domestic",
      energy?.electricity_standard_domestic
    ),
    electricity_standard_production: createFieldStructure(
      "electricity_standard_production",
      energy?.electricity_standard_production
    ),
    electricity_cost_total: createFieldStructure(
      "electricity_cost_total",
      energy?.electricity_cost_total
    ),

    renewable_energies_ppa_combined: createFieldStructure(
      "renewable_energies_ppa_combined",
      energy?.renewable_energies_ppa_combined
    ),
    renewable_energies_ppa_domestic: createFieldStructure(
      "renewable_energies_ppa_domestic",
      energy?.renewable_energies_ppa_domestic
    ),
    renewable_energies_ppa_production: createFieldStructure(
      "renewable_energies_ppa_production",
      energy?.renewable_energies_ppa_production
    ),
    renewable_energies_ppa_cost: createFieldStructure(
      "renewable_energies_ppa_cost",
      energy?.renewable_energies_ppa_cost
    ),

    renewable_energies_on_site_combined: createFieldStructure(
      "renewable_energies_on_site_combined",
      energy?.renewable_energies_on_site_combined
    ),
    renewable_energies_on_site_domestic: createFieldStructure(
      "renewable_energies_on_site_domestic",
      energy?.renewable_energies_on_site_domestic
    ),
    renewable_energies_on_site_production: createFieldStructure(
      "renewable_energies_on_site_production",
      energy?.renewable_energies_on_site_production
    ),
    renewable_energies_on_site_maintenance_and_amortization: createFieldStructure(
      "renewable_energies_on_site_maintenance_and_amortization",
      energy?.renewable_energies_on_site_maintenance_and_amortization
    ),

    natural_gas_combined: createFieldStructure(
      "natural_gas_combined",
      energy?.natural_gas_combined
    ),
    natural_gas_cogeneration: createFieldStructure(
      "natural_gas_cogeneration",
      energy?.natural_gas_cogeneration
    ),
    natural_gas_production_operations: createFieldStructure(
      "natural_gas_production_operations",
      energy?.natural_gas_production_operations
    ),
    natural_gas_domestic: createFieldStructure(
      "natural_gas_domestic",
      energy?.natural_gas_domestic
    ),
    natural_gas_total_cost: createFieldStructure(
      "natural_gas_total_cost",
      energy?.natural_gas_total_cost
    ),

    glp_combined: createFieldStructure("glp_combined", energy?.glp_combined),
    glp_cogeneration: createFieldStructure("glp_cogeneration", energy?.glp_cogeneration),
    glp_production_operations: createFieldStructure("glp_production_operations", energy?.glp_production_operations),
    glp_domestic: createFieldStructure("glp_domestic", energy?.glp_domestic),
    glp_total_cost: createFieldStructure("glp_total_cost", energy?.glp_total_cost),

    heavy_fuel_oil_total: createFieldStructure("heavy_fuel_oil_total", energy?.heavy_fuel_oil_total),
    heavy_fuel_oil_total_cost: createFieldStructure("heavy_fuel_oil_total_cost", energy?.heavy_fuel_oil_total_cost),

    light_fuel_oil_total: createFieldStructure("light_fuel_oil_total", energy?.light_fuel_oil_total),
    light_fuel_oil_total_cost: createFieldStructure("light_fuel_oil_total_cost", energy?.light_fuel_oil_total_cost),

    coal_total: createFieldStructure("coal_total", energy?.coal_total),
    coal_total_cost: createFieldStructure("coal_total_cost", energy?.coal_total_cost),

    diesel_combined: createFieldStructure("diesel_combined", energy?.diesel_combined),
    diesel_cogeneration: createFieldStructure("diesel_cogeneration", energy?.diesel_cogeneration),
    diesel_production_operations: createFieldStructure("diesel_production_operations", energy?.diesel_production_operations),
    diesel_forklifts: createFieldStructure("diesel_forklifts", energy?.diesel_forklifts),
    diesel_total_cost: createFieldStructure("diesel_total_cost", energy?.diesel_total_cost),

    biodiesel_combined: createFieldStructure("biodiesel_combined", energy?.biodiesel_combined),
    biodiesel_cogeneration: createFieldStructure("biodiesel_cogeneration", energy?.biodiesel_cogeneration),
    biodiesel_production_operations: createFieldStructure("biodiesel_production_operations", energy?.biodiesel_production_operations),
    biodiesel_forklifts: createFieldStructure("biodiesel_forklifts", energy?.biodiesel_forklifts),
    biodiesel_total_cost: createFieldStructure("biodiesel_total_cost", energy?.biodiesel_total_cost),

    gasoline_combined: createFieldStructure("gasoline_combined", energy?.gasoline_combined),
    gasoline_cogeneration: createFieldStructure("gasoline_cogeneration", energy?.gasoline_cogeneration),
    gasoline_production_operations: createFieldStructure("gasoline_production_operations", energy?.gasoline_production_operations),
    gasoline_forklifts: createFieldStructure("gasoline_forklifts", energy?.gasoline_forklifts),
    gasoline_total_cost: createFieldStructure("gasoline_total_cost", energy?.gasoline_total_cost),

    biofuel_combined: createFieldStructure("biofuel_combined", energy?.biofuel_combined),
    biofuel_cogeneration: createFieldStructure("biofuel_cogeneration", energy?.biofuel_cogeneration),
    biofuel_production_operations: createFieldStructure("biofuel_production_operations", energy?.biofuel_production_operations),
    biofuel_forklifts: createFieldStructure("biofuel_forklifts", energy?.biofuel_forklifts),
    biofuel_total_cost: createFieldStructure("biofuel_total_cost", energy?.biofuel_total_cost),

    biomass_total: createFieldStructure("biomass_total", energy?.biomass_total),
    biomass_total_cost: createFieldStructure("biomass_total_cost", energy?.biomass_total_cost),

    steam_total: createFieldStructure("steam_total", energy?.steam_total),
    steam_total_cost: createFieldStructure("steam_total_cost", energy?.steam_total_cost),

    // ✅ NUEVOS CAMPOS AGREGADOS - Porcentajes renovables y certificados IREC
    // biodiesel_renewable_percentage: energy?.biodiesel_renewable_percentage || {
    //   code: energyCodes["biodiesel_renewable_percentage"],
    //   unit: unitsRecorded?.["biodiesel_renewable_percentage"] || "%",
    //   value: 0,
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // gasoline_renewable_percentage: energy?.gasoline_renewable_percentage || {
    //   code: energyCodes["gasoline_renewable_percentage"],
    //   unit: unitsRecorded?.["gasoline_renewable_percentage"] || "%",
    //   value: 0,
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    irec_certificates: createFieldStructure(
      "irec_certificates",
      energy?.irec_certificates
    ),
  };
}

export function validationSchema() {
  const schemaFields = {
    period: Yup.string("Dato requerido").required(
      "El campo periodo es obligatorio"
    ),

    electricity_standard_combined: Yup.object({
        value: Yup.number()
           .transform((val) => (val === "" || val == null ? 0 : val))
          .min(0, "Debe ser mayor o igual a 0"), // sin .required()
        unit: Yup.string().when("value", {
          is: (val) => val !== 0 && val != null && val !== "",
          then: (schema) => schema.required("Debe completar la unidad"),
          otherwise: (schema) => schema.notRequired(),
        }),
      }).test(
        "combined-check",
        "No se debe completar si ya ingreso información en el campo electricidad doméstica o de Producción",
        function (combined) {
          const { electricity_standard_domestic, electricity_standard_production } = this.parent;
          const domesticValue = electricity_standard_domestic?.value || 0;
          const industrialValue = electricity_standard_production?.value || 0;
          const combinedValue = combined?.value || 0;
    
          // Si hay valor en alguno de los otros dos y combined tiene valor -> error
          if ((domesticValue > 0 || industrialValue > 0) && combinedValue > 0) {
            return this.createError({ path: "electricity_standard_combined.value" }); // pone el error en value
          }
    
          return true;
        }
      ),
    electricity_standard_domestic: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    electricity_standard_production: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    electricity_cost_total: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    renewable_energies_ppa_combined: Yup.object({
        value: Yup.number()
           .transform((val) => (val === "" || val == null ? 0 : val))
          .min(0, "Debe ser mayor o igual a 0"), // sin .required()
        unit: Yup.string().when("value", {
          is: (val) => val !== 0 && val != null && val !== "",
          then: (schema) => schema.required("Debe completar la unidad"),
          otherwise: (schema) => schema.notRequired(),
        }),
      }).test(
        "combined-check",
        "No se debe completar si ya ingreso información en el campo Energías Renovables (PPA) doméstico o de Producción",
        function (combined) {
          const { renewable_energies_ppa_domestic, renewable_energies_ppa_production } = this.parent;
          const domesticValue = renewable_energies_ppa_domestic?.value || 0;
          const industrialValue = renewable_energies_ppa_production?.value || 0;
          const combinedValue = combined?.value || 0;
    
          // Si hay valor en alguno de los otros dos y combined tiene valor -> error
          if ((domesticValue > 0 || industrialValue > 0) && combinedValue > 0) {
            return this.createError({ path: "renewable_energies_ppa_combined.value" }); // pone el error en value
          }
    
          return true;
        }
      ),
    renewable_energies_ppa_domestic: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    renewable_energies_ppa_production: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    renewable_energies_ppa_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    renewable_energies_on_site_combined:  Yup.object({
        value: Yup.number()
           .transform((val) => (val === "" || val == null ? 0 : val))
          .min(0, "Debe ser mayor o igual a 0"), // sin .required()
        unit: Yup.string().when("value", {
          is: (val) => val !== 0 && val != null && val !== "",
          then: (schema) => schema.required("Debe completar la unidad"),
          otherwise: (schema) => schema.notRequired(),
        }),
      }).test(
        "combined-check",
        "No se debe completar si ya ingreso información en el campo Energías renovables producidas en el sitio doméstico o de Producción",
        function (combined) {
          const { renewable_energies_on_site_domestic, renewable_energies_on_site_production } = this.parent;
          const domesticValue = renewable_energies_on_site_domestic?.value || 0;
          const industrialValue = renewable_energies_on_site_production?.value || 0;
          const combinedValue = combined?.value || 0;
    
          // Si hay valor en alguno de los otros dos y combined tiene valor -> error
          if ((domesticValue > 0 || industrialValue > 0) && combinedValue > 0) {
            return this.createError({ path: "renewable_energies_on_site_combined.value" }); // pone el error en value
          }
    
          return true;
        }
      ),
    renewable_energies_on_site_domestic: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    renewable_energies_on_site_production: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    renewable_energies_on_site_maintenance_and_amortization: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    natural_gas_combined:  Yup.object({
        value: Yup.number()
           .transform((val) => (val === "" || val == null ? 0 : val))
          .min(0, "Debe ser mayor o igual a 0"), // sin .required()
        unit: Yup.string().when("value", {
          is: (val) => val !== 0 && val != null && val !== "",
          then: (schema) => schema.required("Debe completar la unidad"),
          otherwise: (schema) => schema.notRequired(),
        }),
      }).test(
        "combined-check",
        "No se debe completar si ya ingreso información en el campo Gas Natural doméstico o de Producción",
        function (combined) {
          const { natural_gas_domestic, natural_gas_production_operations } = this.parent;
          const domesticValue = natural_gas_domestic?.value || 0;
          const industrialValue = natural_gas_production_operations?.value || 0;
          const combinedValue = combined?.value || 0;
    
          // Si hay valor en alguno de los otros dos y combined tiene valor -> error
          if ((domesticValue > 0 || industrialValue > 0) && combinedValue > 0) {
            return this.createError({ path: "natural_gas_combined.value" }); // pone el error en value
          }
    
          return true;
        }
      ),
    natural_gas_cogeneration: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    natural_gas_production_operations: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    natural_gas_domestic: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    natural_gas_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    glp_combined: Yup.object({
        value: Yup.number()
           .transform((val) => (val === "" || val == null ? 0 : val))
          .min(0, "Debe ser mayor o igual a 0"), // sin .required()
        unit: Yup.string().when("value", {
          is: (val) => val !== 0 && val != null && val !== "",
          then: (schema) => schema.required("Debe completar la unidad"),
          otherwise: (schema) => schema.notRequired(),
        }),
      }).test(
        "combined-check",
        "No se debe completar si ya ingreso información en el campo GLP doméstica o de Producción",
        function (combined) {
          const { glp_domestic, glp_production_operations } = this.parent;
          const domesticValue = glp_domestic?.value || 0;
          const industrialValue = glp_production_operations?.value || 0;
          const combinedValue = combined?.value || 0;
    
          // Si hay valor en alguno de los otros dos y combined tiene valor -> error
          if ((domesticValue > 0 || industrialValue > 0) && combinedValue > 0) {
            return this.createError({ path: "glp_combined.value" }); // pone el error en value
          }
    
          return true;
        }
      ),
    glp_cogeneration: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    glp_production_operations: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    glp_domestic: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    glp_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    heavy_fuel_oil_total: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    heavy_fuel_oil_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    light_fuel_oil_total: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    light_fuel_oil_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    coal_total: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    coal_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    diesel_combined: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    diesel_cogeneration: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    diesel_production_operations: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    diesel_forklifts: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    diesel_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    biodiesel_combined: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    biodiesel_cogeneration: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    biodiesel_production_operations: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    biodiesel_forklifts: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biodiesel_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    gasoline_combined: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    gasoline_cogeneration: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    gasoline_production_operations: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    gasoline_forklifts: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    gasoline_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biofuel_combined: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biofuel_cogeneration: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biofuel_production_operations: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biofuel_forklifts: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biofuel_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biomass_total: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    biomass_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    steam_total: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    steam_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

    steam_total_cost: Yup.object({
      value: Yup.number()
        .min(0, "Debe ser mayor o igual a 0")
        .required("Debe ingresar un valor"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  };

  // // Generar esquema para cada código de energía
  // Object.keys(energyCodes).forEach((key) => {
  //   schemaFields[key] = Yup.object({
  //     value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
  //     unit: Yup.string().when("value", {
  //       is: (val) => val !== 0 && val !== null && val !== "",
  //       then: (schema) => schema.required("Debe completar la unidad"),
  //       otherwise: (schema) => schema.notRequired(),
  //     }),
  //   });
  // });

  return Yup.object(schemaFields);
}
